import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

const ORGANISATION_ADDRESS_RESOURCE = 'organisationAddress';

const OrganisationAddressService = ComposedComponent =>
  reduxFetch([
    {
      resource: ORGANISATION_ADDRESS_RESOURCE,
      method: 'get',
      request: organisationId => ({
        url: apiRoutes.organisationAddress(organisationId),
        clearValueOnRequest: true,
      }),
    },
  ])(ComposedComponent);

export default OrganisationAddressService;
